import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	expandEpicLabel: {
		id: 'software-backlog-panel.common.card.expand.expand-epic-label',
		defaultMessage: 'Expand {epicName} epic summary',
		description: 'Accessibility label for a button that expands the epic card contents.',
	},
	collapseEpicLabel: {
		id: 'software-backlog-panel.common.card.expand.collapse-epic-label',
		defaultMessage: 'Collapse {epicName} epic summary',
		description: 'Accessibility label for a button that collapses the epic card contents.',
	},
	expandVersionLabel: {
		id: 'software-backlog-panel.common.card.expand.expand-version-label',
		defaultMessage: 'Expand {versionName} version summary',
		description: 'Accessibility label for a button that expands the version card contents.',
	},
	collapseVersionLabel: {
		id: 'software-backlog-panel.common.card.expand.collapse-version-label',
		defaultMessage: 'Collapse {versionName} version summary',
		description: 'Accessibility label for a button that collapses the version card contents.',
	},
});
